import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { TranslatedString } from '@bosch/bt-ui';

const WarningDialog = ({
    title = 'Warning',
    descTranslatedId,
    onConfirm,
    onCancel,
    show
}) => {
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        }
    };

    return (
        <Modal show={show} onHide={handleCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {descTranslatedId && (
                    <div className="dialog-description">
                        <TranslatedString stringId={descTranslatedId} />
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer> 
                <Button variant="primary" onClick={handleConfirm}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default WarningDialog;
